import React from 'react';
import { useLocation } from 'react-router-dom';
import FinanceTicker from '../FinanceTicker';
import CurrencyHistoryChart from '../CurrencyHistoryChart';
import Copyrights from '../Copyrights';
import Footer from '../Footer';
import SEO from '../SEO';
import { currencyName, isValidCurrencyCode } from '../../lib/ecbFx';
import '../styles/pages.css';

export default function Finances() {
  const params = new URLSearchParams(useLocation().search);
  const rawCurrency = params.get('currency');
  const currency = rawCurrency ? rawCurrency.toUpperCase() : null;

  if (currency && isValidCurrencyCode(currency)) {
    return (
      <>
        <SEO
          title={`EUR/${currency} Exchange Rate History`}
          description={`Historical EUR/${currency} (Euro to ${currencyName(currency)}) reference exchange rate, sourced from the European Central Bank.`}
          path={`/finances?currency=${currency}`}
        />
        <main className='finances'>
          <CurrencyHistoryChart currency={currency} />
        </main>
        <Copyrights/>
        <Footer/>
      </>
    );
  }

  return (
    <>
      <SEO
        title='Finance'
        description='Live European Central Bank reference exchange rates, tracked continuously for enterprises managing multi-currency operations.'
        path='/finances'
      />
      <main className='finances-page'>
        <section className='finances-hero'>
          <FinanceTicker />
          <div className='finances-intro'>
            <div className='section-header finances-intro__header'>
              <span className='finances-eyebrow'>Market reference data</span>
              <h1>Finance</h1>
              <p>
                Live currency reference rates from the European Central Bank, so your team always has
                an up-to-date view of the euro against major world currencies. Click any pair below for
                its recent history.
              </p>
            </div>
            <div className='finances-highlights'>
              <article className='finances-highlight'>
                <h2>Live ECB reference rates</h2>
                <p>Track the euro against major global currencies in real time.</p>
              </article>
              <article className='finances-highlight'>
                <h2>Historical context</h2>
                <p>Open any pair to inspect recent movement and trend history.</p>
              </article>
            </div>
          </div>
        </section>
      </main>
      <Copyrights/>
      <Footer/>
    </>
  );
}
